/** Shared quick-contact links (+91-93192-19252 — do not use for email). */
export const LANDMARKS_PHONE_DISPLAY = "+91-93192-19252";
export const LANDMARKS_PHONE_TEL = "tel:+919319219252";
export const LANDMARKS_WHATSAPP_URL = "https://wa.me/919319219252";

/**
 * Opens the native phone / dial pad on phones (tel: handler).
 * Uses explicit navigation so in-app browsers and mobile Safari reliably show the dialer.
 */
export function openTelDialer(event) {
    if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
    }
    window.location.href = LANDMARKS_PHONE_TEL;
}
